import React from "react";
import styled from "styled-components";
import { Highlight, themes } from "prism-react-renderer";

const Wrapper = styled.div`
  margin: 20px 0;
  border-radius: 10px;
  overflow: hidden;
  background: #000000;
  border: 1px solid rgba(42, 199, 220, 0.3);
  font-size: 14px;
  line-height: 1.6;

  @media (max-width: 640px) {
    font-size: 13px;
    border-radius: 8px;
  }
`;

const LanguageLabel = styled.div`
  padding: 8px 16px 0;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #2ac7dc;
  font-family: ui-sans-serif, system-ui, sans-serif;
`;

const Pre = styled.pre`
  margin: 0 !important;
  padding: 16px 20px;
  overflow-x: auto;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,
    monospace;
  font-size: inherit;
  line-height: inherit;
  white-space: pre;
  tab-size: 2;
  border: 0 !important;

  @media (max-width: 640px) {
    padding: 12px 16px;
  }
`;

const Line = styled.div`
  display: table-row;
`;

const LineContent = styled.span`
  display: table-cell;
`;

const LANGUAGE_LABELS = {
  js: "JavaScript",
  javascript: "JavaScript",
  jsx: "JSX",
  ts: "TypeScript",
  typescript: "TypeScript",
  tsx: "TSX",
  py: "Python",
  python: "Python",
  bash: "Bash",
  sh: "Shell",
  shell: "Shell",
  zsh: "Zsh",
  json: "JSON",
  html: "HTML",
  css: "CSS",
  md: "Markdown",
  markdown: "Markdown",
  yaml: "YAML",
  yml: "YAML"
};

function extractCode(children) {
  if (typeof children === "string")
    return { code: children, language: "text" };
  const codeEl = React.Children.toArray(children).find((c) =>
    c && c.props && c.props.mdxType !== undefined
      ? c.props.mdxType === "code"
      : c && c.type === "code"
  );
  const node = codeEl || children;
  const className = (node && node.props && node.props.className) || "";
  const match = /language-(\w+)/.exec(className);
  const language = match ? match[1] : "text";
  const raw = node && node.props && node.props.children;
  const code = typeof raw === "string" ? raw.replace(/\n$/, "") : "";
  return { code, language };
}

export function GuideCodeBlock({ children }) {
  const { code, language } = extractCode(children);
  const label = LANGUAGE_LABELS[language] || language;

  return (
    <Wrapper>
      {label && label !== "text" && (
        <LanguageLabel>{label}</LanguageLabel>
      )}
      <Highlight
        code={code}
        language={language}
        theme={themes.nightOwl}
      >
        {({
          className,
          style,
          tokens,
          getLineProps,
          getTokenProps
        }) => (
          <Pre
            className={className}
            style={{ ...style, background: "transparent" }}
          >
            {tokens.map((line, i) => {
              const lineProps = getLineProps({ line });
              return (
                <Line key={i} {...lineProps}>
                  <LineContent>
                    {line.map((token, key) => (
                      <span key={key} {...getTokenProps({ token })} />
                    ))}
                  </LineContent>
                </Line>
              );
            })}
          </Pre>
        )}
      </Highlight>
    </Wrapper>
  );
}
